// Collection Filter Menu - Radio Button + Collapse functionality
(function() {
  'use strict';

  function initFilterMenu() {
    // Handle radio changes - navigate to collection
    document.querySelectorAll('.filter-menu__radio').forEach(function(radio) {
      radio.addEventListener('change', function(e) {
        var url = this.getAttribute('data-collection-url');
        if (!url) return;
        
        // Save expanded states before navigation
        saveExpandedStates();
        
        // Navigate
        window.location.href = url;
      });
    });

    // Handle toggle clicks - expand/collapse
    document.querySelectorAll('[data-action="toggle-collapsible"]').forEach(function(toggle) {
      toggle.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        var controls = this.getAttribute('aria-controls');
        var content;
        
        if (controls) {
          content = document.getElementById(controls);
        } else {
          var parent = this.closest('.filter-menu__item');
          if (parent) {
            content = parent.querySelector('.filter-menu__content');
          }
        }
        
        if (content) {
          var isExpanded = this.getAttribute('aria-expanded') === 'true';
          
          // Handle close-siblings if needed
          var closeSiblings = this.getAttribute('data-close-siblings') === 'true';
          if (closeSiblings && !isExpanded) {
            var parent = this.closest('.filter-menu__list');
            if (parent) {
              parent.querySelectorAll('[data-action="toggle-collapsible"][aria-expanded="true"]').forEach(function(sibling) {
                if (sibling !== toggle) {
                  var siblingControls = sibling.getAttribute('aria-controls');
                  var siblingContent = siblingControls ? document.getElementById(siblingControls) : 
                    sibling.closest('.filter-menu__item').querySelector('.filter-menu__content');
                  
                  if (siblingContent) {
                    sibling.setAttribute('aria-expanded', 'false');
                    siblingContent.setAttribute('aria-hidden', 'true');
                    siblingContent.style.height = '0';
                    siblingContent.style.overflow = 'hidden';
                  }
                }
              });
            }
          }
          
          if (isExpanded) {
            this.setAttribute('aria-expanded', 'false');
            content.setAttribute('aria-hidden', 'true');
            content.style.height = '0';
            content.style.overflow = 'hidden';
          } else {
            this.setAttribute('aria-expanded', 'true');
            content.setAttribute('aria-hidden', 'false');
            content.style.height = 'auto';
            content.style.overflow = 'visible';
          }
        }
      });
    });

    restoreExpandedStates();
  }

  function saveExpandedStates() {
    var states = {};
    document.querySelectorAll('[data-action="toggle-collapsible"]').forEach(function(toggle, index) {
      var key = toggle.getAttribute('aria-controls') || 'toggle-' + index;
      states[key] = toggle.getAttribute('aria-expanded') === 'true';
    });
    sessionStorage.setItem('filterMenuStates', JSON.stringify(states));
  }

  function restoreExpandedStates() {
    var saved = sessionStorage.getItem('filterMenuStates');
    if (!saved) return;
    
    try {
      var states = JSON.parse(saved);
      Object.keys(states).forEach(function(key) {
        if (!states[key]) return;
        
        var toggle = document.querySelector('[aria-controls="' + key + '"]');
        if (!toggle && key.indexOf('toggle-') === 0) {
          var index = parseInt(key.replace('toggle-', ''));
          var toggles = document.querySelectorAll('[data-action="toggle-collapsible"]');
          toggle = toggles[index];
        }
        
        if (toggle) {
          var controls = toggle.getAttribute('aria-controls');
          var content = controls ? document.getElementById(controls) : 
            toggle.closest('.filter-menu__item').querySelector('.filter-menu__content');
          
          if (content) {
            toggle.setAttribute('aria-expanded', 'true');
            content.setAttribute('aria-hidden', 'false');
            content.style.height = 'auto';
            content.style.overflow = 'visible';
          }
        }
      });
      
      sessionStorage.removeItem('filterMenuStates');
    } catch(e) {
      console.error('Error restoring filter states:', e);
    }
  }

  /**
   * Reset the category radios to the state rendered by the server (= the collection in the URL).
   * Without this, the browser back button restores the page from the back/forward cache (or restores
   * form state) with the radio the user clicked before leaving, e.g. "Windows 11" stays selected
   * on /collections/betriebssysteme.
   */
  function syncRadiosWithPage() {
    document.querySelectorAll('.filter-menu__radio').forEach(function(radio) {
      radio.checked = radio.defaultChecked;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      syncRadiosWithPage();
      initFilterMenu();
    });
  } else {
    syncRadiosWithPage();
    initFilterMenu();
  }

  // Back/forward navigation (bfcache restore) and late browser form-state restore
  window.addEventListener('pageshow', syncRadiosWithPage);
  window.addEventListener('load', syncRadiosWithPage);
})();